import isEqual from 'lodash-es/isEqual'
import omit from 'lodash-es/omit'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { FILTER_NAME_SUB_MENU } from '../../../../../constants/filter'
import { getMassActionsSuccessItemsLength } from '../../../../../utils/massActions'
import {
  FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME,
  getFormikEntityActionConfigFieldsInitialValuesPayload,
} from '../../../../Formik'
import {
  REQUEST_ACTION_UPDATE_STATUS_ITEM,
  REQUEST_MASS_ACTION_ID_KEY,
  REQUEST_MASS_ACTION_NAMES,
} from '../../../Request.constants.actions'
import { getRequestMassActionUnreadFilter } from '../../../Request.utils.actions'
import {
  getRequestEditStatusModalSubmitPayload,
  getRequestEditStatusModalWithActionTypesInitialValues,
} from '../../../RequestEditStatusModal'
import { getRequestBoardColumn } from '../../RequestBoard.utils'

import { REQUEST_BOARD_STATUS_KEPT_FILTER_NAMES } from './useRequestBoardChangeStatus.constants'

function isRequestBoardStatusKeptFilterName(name) {
  return REQUEST_BOARD_STATUS_KEPT_FILTER_NAMES.includes(name)
}

export function getRequestBoardDragData(event) {
  return event.active?.data.current ?? EMPTY_OBJECT
}

export function getRequestBoardDropStatus(event) {
  return event.over?.data.current?.status ?? null
}

export function isRequestBoardCardMoved({ item, sourceStatus, targetStatus }) {
  return Boolean(item) && targetStatus !== null && targetStatus !== sourceStatus
}

export function getRequestBoardMove({ filterValues, item, source, target }) {
  return {
    filterValues,
    isInserted: !target.isExcluded,
    isSourceLoadingMore: source.isLoadingMore,
    item,
    sourceGeneration: source.reloadGenerationRef.current,
    sourceStatus: source.status,
    targetGeneration: target.reloadGenerationRef.current,
    targetStatus: target.status,
  }
}

export function getRequestBoardMovedItem({ item, status }) {
  return { ...item, status }
}

export function getRequestBoardMoveColumns({ columns, move }) {
  return {
    source: getRequestBoardColumn({ columns, status: move.sourceStatus }),
    target: getRequestBoardColumn({ columns, status: move.targetStatus }),
  }
}

export function isRequestBoardInsertRolledBack({ isChanged, isListed, move }) {
  return move.isInserted && (!isChanged || !isListed)
}

// A filter changed during the save may have let the table read the total from
// before it.
export function isRequestBoardTableReloadNeeded({
  columns,
  filterValues,
  isListed,
  move,
}) {
  const { source, target } = getRequestBoardMoveColumns({ columns, move })

  return (
    !isListed ||
    !isEqual(filterValues, move.filterValues) ||
    source.isExcluded !== target.isExcluded
  )
}

// Only filters on what the save changes can drop the card from the listing.
export function isRequestBoardListingCheckNeeded(filterValues) {
  return Object.keys(filterValues ?? EMPTY_OBJECT).some(
    name => !isRequestBoardStatusKeptFilterName(name)
  )
}

export function isRequestBoardMoveTargetListed({ columns, move }) {
  return !getRequestBoardMoveColumns({ columns, move }).target.isExcluded
}

// The count of a column that still has other unsaved moves waits for the last
// of them: the server does not have them yet.
export function isRequestBoardColumnRecountDue({ column, id }) {
  return [...column.departedIds, ...column.insertedIds].every(
    pendingId => pendingId === id
  )
}

export function isRequestBoardSourceReloadNeeded({ isChanged, move }) {
  return isChanged && move.isSourceLoadingMore
}

export function isRequestBoardMoveOutdated({ move, source, target }) {
  return (
    source.reloadGenerationRef.current !== move.sourceGeneration ||
    target.reloadGenerationRef.current !== move.targetGeneration
  )
}

export function getRequestBoardChangeStatusParams({
  filterValues,
  id,
  status,
  sub,
}) {
  const statusValues = getRequestEditStatusModalWithActionTypesInitialValues({
    status,
  })

  return {
    ...getFormikEntityActionConfigFieldsInitialValuesPayload(
      statusValues[FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]
    ),
    action: REQUEST_MASS_ACTION_NAMES[REQUEST_ACTION_UPDATE_STATUS_ITEM],
    all: false,
    filters: {
      ...omit(filterValues, [FILTER_NAME_SUB_MENU]),
      [REQUEST_MASS_ACTION_ID_KEY]: [id],
      unread: getRequestMassActionUnreadFilter(sub),
    },
    payload: getRequestEditStatusModalSubmitPayload(statusValues),
  }
}

export function isRequestBoardStatusChanged(data) {
  return getMassActionsSuccessItemsLength(data) > 0
}

export function isRequestBoardItemListed(data) {
  return data.total > 0
}
